import { Field, JsonParseError, JsonParseErrorCode } from "sparkson";

export class Soundtrack {

  constructor(
    @Field("u", true) public musicUrl: string,
    @Field("so", true) public startOffset: number = 0,
    @Field("eo", true) public endOffset: number = 0,
    @Field("fid", true) public fadeInDuration: number = 0,
    @Field("fod", true) public fadeOutDuration: number = 1500
  ) {
    this.changeMillisecondsToSeconds();
    this.validate();
  }

  private changeMillisecondsToSeconds() { 
    this.startOffset /= 1000;
    this.endOffset /= 1000;
    this.fadeInDuration /= 1000;
    this.fadeOutDuration /= 1000;
  }

  private validate() {

    if (!this.musicUrl || this.musicUrl === "") {
      throw new JsonParseError("musicUrl must be defined)", JsonParseErrorCode.VALIDATION_FAILED);
    }

  }

}
